var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center flex-column box"},[_c('b-img',{staticClass:"img",attrs:{"fluid":"","alt":"No account","src":require('@/assets/images/common/no-data-table.svg')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }